<div class="why-inyova-holder">
  <h4 class="ui-headline">{{ 'new_strategy.why_yova.h4' | translate }}</h4>
  <ul>
    <li>
      <span class="icon-i-checkmark-circle"></span>
      {{ 'new_strategy.why_yova.li-1' | translate }}
    </li>
    <li>
      <span class="icon-i-checkmark-circle"></span>
      <ng-container *ngIf="kind === '3b'; else show3AFee">
        {{ 'new_strategy.why_yova.li-2-1' | translate }} {{ totalFee | translatePercent: language }}
        {{ 'new_strategy.why_yova.li-2-2' | translate }}
      </ng-container>
      <ng-template #show3AFee>
        {{ 'new_strategy.why_yova.li-2_3a' | translate: { fee3A: totalFee | translatePercent: language } }}
      </ng-template>
    </li>
    <li>
      <span class="icon-i-checkmark-circle"></span>
      {{ 'new_strategy.why_yova.li-3' | translate }}
    </li>
  </ul>
  <p (click)="trackActivity('[Link] Get in touch')" [innerHtml]="'new_strategy.portfolio_screen.roman' | translate"></p>
  <div class="xs-only sm-only">
    <app-guarantee-shield (guaranteeModal)="toggleGuaranteeModal()"></app-guarantee-shield>
  </div>
</div>
<app-guarantee *ngIf="showGuarantee" (guaranteeOpened)="toggleGuaranteeModal()"></app-guarantee>
